var SearchVariant = (function ($) {

    SearchVariant = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];

        // CONST
        that.CUSTOM_MOBILE_WIDTH = 768;

        that.analytics_data = options.analytics_data || null;

        that.class = {
            variant: 'js-variant',
            variant_card_wrapper: 'js-variant-card-wrapper',
            variant_card: 'js-variant-card',
            variant_route: 'js-variant-route',
            variant_price_buttons_wrapper: 'js-variant-price-buttons-wrapper',
            variant_brands_wrapper: 'js-brands-wrapper',
            variant_segments_wrapper: 'js-segments-wrapper',
            variant_segment: 'js-segment',
            variant_selected: 'selected',
            variant_reject: 'variant-reject',

            price: 'js-price',
            price_selected: 'js-price-selected',

            drawer_brands_trigger: 'js-drawer-brands-trigger',
            drawer_segments_trigger: 'js-drawer-segments-trigger',
            drawer_localtime_disclaimer: 'js-drawer-localtime-disclaimer',

            brand_submit: 'js-brand-submit',
            brand_cancel: 'js-brand-cancel',
            brand_selected_features_holder: 'js-brand-features-holder',
            brand_selected_features_src: 'js-brand-features-src',
            fareremark_info: 'js-fareremark-info'
        };

        // DYNAMIC VARS
        that.drawer_segment_hide_footer = false;
        that.variant_drawer_ai = 0;
        that.variant_drawer_instances = [];

        that.$price_selected = null;
        that.smartup_segments_charge_off = 0


        that.onSelect = (options['onSelect'] || function () {});
        that.onCancel = (options['onCancel'] || function () {});
        that.onShowFareremark = (options['onShowFareremark'] || function () {});

        // INIT
        that.init();
    };

    SearchVariant.prototype.init = function () {
        var that = this;

        //
        that.__initHandlers(that.$wrapper);
    };

    SearchVariant.prototype.select = function (price_hash) {
        var that = this;
        return that.__select(price_hash);
    }

    SearchVariant.prototype.cancel = function () {
        var that = this;
        return that.__cancel();
    }

    SearchVariant.prototype.getSelectedPrice = function () {
        var that = this;

        if (!that.$price_selected) {
            that.$price_selected = that.$wrapper.find('.' + that.class.price_selected);
        }

        return (that.$price_selected && that.$price_selected.length) ? that.$price_selected : null;
    }

    SearchVariant.prototype.getSelectedPriceHash = function () {
        var that = this,
            $selected_price = that.getSelectedPrice();

        if (!$selected_price || !$selected_price.length) {
            return null;
        }

        return $selected_price.data('hash');
    }

    //

    /**
     * This method called from that.init() & UIDrawer.onOpen.
     * @param $wrapper Dude, just don't remove this param..
     * @private
     */
    SearchVariant.prototype.__initHandlers = function ($wrapper) {
        var that = this;

        $wrapper.on('click', '.' + that.class.drawer_segments_trigger, function (e) {
            e.preventDefault();
            that.__drawerSegmentsCall();
        });

        $wrapper.on('click', '.' + that.class.drawer_brands_trigger, function (e) {
            that.__emitViewItemListAnalyticsEvent();
            if (window.innerWidth < that.CUSTOM_MOBILE_WIDTH) {
                e.preventDefault();
                that.__drawerBrandsCall();
            }
        });

        $wrapper.on('click', '.' + that.class.brand_submit, function (e) {
            e.preventDefault();
            var $price = $(this).parents('.' + that.class.price);
            that.__select($price.data('hash'));
        });

        $wrapper.on('click', '.' + that.class.brand_cancel, function (e) {
            e.preventDefault();
            that.__cancel();
        });

        $wrapper.on('click', '.' + that.class.fareremark_info, function (e) {
            e.preventDefault();

            var $self = $(this),
                $price = $self.parents('.' + that.class.price),
                hash = $price.data('hash');
            if (!hash) {
                var $features = $self.parents('.' + that.class.brand_selected_features_holder);
                hash = $features.data('price-hash');
            }

            if (that.onShowFareremark) {
                that.onShowFareremark(hash, that);
            }
        });
    };

    SearchVariant.prototype.__select = function (price_hash) {
        var that = this,
            $price = that.$wrapper.find('.' + that.class.price + '[data-hash="' + price_hash + '"]'),
            $price_brand_features = $price.find('.' + that.class.brand_selected_features_src).clone(),
            $price_brand_features_holder = that.$wrapper.find('.' + that.class.brand_selected_features_holder);

        $price.addClass(that.class.price_selected);
        that.$price_selected = $price;

        $price_brand_features_holder
            .attr('data-price-hash', $price.data('hash'))
            .data('price-hash', $price.data('hash'))
            .append($price_brand_features.html());

        that.$wrapper.addClass(that.class.variant_selected);
        that.$wrapper.siblings('.' + that.class.variant).addClass(that.class.variant_reject);
        that.__closeDrawers();
        that.drawer_segment_hide_footer = true;

        that.smartup_segments_charge_off = $price.data('segments-charge-off');

        if (that.analytics_data) {
            var items = JSON.parse(JSON.stringify(that.analytics_data.items)).filter(item => item._price_hash === price_hash);
            items.forEach(function (item) {
                var _item = Object.assign({}, item);
                _item.variant = 'main';
                delete _item._price_hash;
                $.sa.analytics.gtag('event', 'select_item', {
                    list_item_name: that.analytics_data.list_item_name,
                    items: [_item]
                });
            });
        }

        that.onSelect(that);
    };

    SearchVariant.prototype.__cancel = function () {
        var that = this,
            selected_price_hash = that.getSelectedPriceHash(),
            $brand_selected_features_holder = that.$wrapper.find('.' + that.class.brand_selected_features_holder);

        that.$wrapper.find(that.class.price).removeClass(that.class.price_selected);

        that.$wrapper.removeClass(that.class.variant_selected);
        that.$wrapper.siblings('.' + that.class.variant).removeClass(that.class.variant_reject);
        $brand_selected_features_holder.empty();
        that.drawer_segment_hide_footer = false;
        that.$price_selected = null;
        UIToggle.prototype.hideAll(that.$wrapper, null);

        that.onCancel(that, selected_price_hash);
    };

    SearchVariant.prototype.__drawerSegmentsCall = function () {
        var that = this,
            $variant_route = that.$wrapper.find('.' + that.class.variant_route),
            drawer_header = [
                $variant_route.find('.variant-point.departure .location-city').text(),
                $variant_route.find('.variant-point.arrival .location-city').text()
            ],
            variant_header_description = $variant_route.find('.duration').text(),

            $drawer_content = that.$wrapper.find('.' + that.class.variant_segments_wrapper).clone(),
            $drawer_footer = that.$wrapper.find('.' + that.class.variant_price_buttons_wrapper),

            $variant_segments = that.$wrapper.find('.' + that.class.variant_segment),
            drawer_fullscreen = $variant_segments.length > 1,
            drawer_fluid = !drawer_fullscreen,
            drawer_disable_scroll = !drawer_fullscreen;

        $drawer_content.append(that.$wrapper.find('.' + that.class.drawer_localtime_disclaimer).html());

        var drawer_id = that.variant_drawer_ai++;

        $.uiDrawer({
            position: 'bottom',
            fluid: drawer_fluid,
            disable_content_scroll: drawer_disable_scroll,
            mobile_fullscreen: drawer_fullscreen,
            header_contrast: true,
            custom_class: 'narrow variant-card drawer-segments',
            header_title: drawer_header.join(' — '),
            header_description: variant_header_description,
            content: $drawer_content.html(),
            footer: that.drawer_segment_hide_footer !== true ? $drawer_footer.clone() : null,
            onOpen: function ($drawer_wrapper, drawer_instance) {
                that.__initHandlers($drawer_wrapper);
                that.variant_drawer_instances[drawer_id] = drawer_instance;
            },
            onClose: function () {
                delete that.variant_drawer_instances[drawer_id];
            }
        });
    };

    SearchVariant.prototype.__emitViewItemListAnalyticsEvent = function () {
        var that = this;
        if (that.analytics_data) {
            var items = JSON.parse(JSON.stringify(that.analytics_data.items));
            items.forEach(item => {
                item.variant = 'main';
                delete item._price_hash;
            });
            $.sa.analytics.gtag('event', 'view_item_list', {
                item_list_name: that.analytics_data.list_item_name,
                items: items
            });
        }
    };

    SearchVariant.prototype.__drawerBrandsCall = function () {
        var that = this,
            $variant_card_wrapper = that.$wrapper.find('.' + that.class.variant_card_wrapper),
            $variant_card = $variant_card_wrapper.find('.' + that.class.variant_card),
            variant_date = $variant_card.find('.' + that.class.variant_route + ' .variant-point.departure .date-short').html(),

            drawer_header_title = $variant_card.data('variant-direction') + variant_date,
            drawer_header_description = [
                $variant_card.find('.' + that.class.variant_route + ' .variant-point.departure .location-city').text(),
                $variant_card.find('.' + that.class.variant_route + ' .variant-point.arrival .location-city').text()
            ],
            drawer_content_top = $variant_card_wrapper.html(),
            $drawer_content = $variant_card.find('.' + that.class.variant_brands_wrapper),
            drawer_custom_class = 'variant-card-accent variant-card variant drawer-brands js-variant';

        var drawer_id = that.variant_drawer_ai++;

        $.uiDrawer({
            position: 'bottom',
            mobile_fullscreen: true,
            custom_class: drawer_custom_class,
            header_contrast: true,
            header_title: drawer_header_title,
            header_description: drawer_header_description.join(' — '),
            content_top: drawer_content_top,
            content: $drawer_content.clone().html(),
            onOpen: function ($drawer_wrapper, drawer_instance) {
                that.drawer_segment_hide_footer = true;
                that.__initHandlers($drawer_wrapper);
                that.variant_drawer_instances[drawer_id] = drawer_instance;
            },
            onClose: function () {
                that.drawer_segment_hide_footer = false;
                delete that.variant_drawer_instances[drawer_id];
            }
        });
    };

    SearchVariant.prototype.__closeDrawers = function () {
        var that = this;

        $.each(that.variant_drawer_instances, function (i, drawer_instance) {
            if (drawer_instance) {
                drawer_instance.close();
            }
            delete that.variant_drawer_instances[i];
        });
        that.variant_drawer_ai = 0;
        that.variant_drawer_instances = [];
    };

    return SearchVariant;
})($);
